export default {
  body: {
    emptyDataSourceMessage: 'Nenhum registro para exibir',
    filterRow: {
      filterTooltip: 'Filtrar',
    },
    editRow: {
      saveTooltip: 'Salvar',
      cancelTooltip: 'Cancelar',
      deleteText: 'Tem certeza de excluir esse registro?',
    },
    addTooltip: 'Adicionar',
    deleteTooltip: 'Excluir',
    editTooltip: 'Editar',
  },
  header: {
    actions: 'Ações',
    print: 'Imprimir',
    showHideColumn: 'Exibir/Ocultar Colunas',
    filter: 'Filtrar',
  },
  grouping: {
    placeholder: 'Arrastar cabeçalhos ...',
  },
  pagination: {
    firstTooltip: 'Primeira página',
    previousTooltip: 'Página anterior',
    nextTooltip: 'Próxima página',
    labelDisplayedRows: '{from}-{to} de {count}',
    labelRowsPerPage: 'Registros por página:',
    lastTooltip: 'Última página',
    labelRowsSelect: 'registros',
  },
  toolbar: {
    addRemoveColumns: 'Adicionar ou remover colunas',
    nRowsSelected: '{0} linha(s) selecionada(s)',
    showColumnsTitle: 'Mostrar Colunas',
    showColumnsAriaLabel: 'Mostrar Colunas',
    exportTitle: 'Exportar',
    exportAriaLabel: 'Exportar',
    exportName: 'Exportar como CSV',
    searchTooltip: 'Pesquisar',
    searchPlaceholder: 'Pesquisar',
    newTitle: 'Novo',
    newAriaLabel: 'Criar um novo registro',
  },

};
